var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blank-layout"}},[_vm._t("default"),_c('blank-footer-menu')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }